import RegulationWrapper from 'components/Regulation/RegulationWrapper';
import React from 'react';
import { Container } from 'ui';

type ContentTextProps = {
    data: any
    isFirstHeading?: boolean
};
const ContentText: React.FC<ContentTextProps> = ({ data, isFirstHeading }) => {
    return (
        <Container>
            <RegulationWrapper data={data} isFirstHeading={isFirstHeading} />
        </Container>
    );
};
export default ContentText;
